import React, { useState, useEffect } from 'react';
import { getCentroCosto } from '../../services/CentroCostos';
import { getMaquinas } from '../../services/Maquinas';
import { getDocumentosGenerales } from "../../services/DocumentosGenerales";
import { getManDocuMaqFiltro } from "../../services/ManDocuMaq";
import { getMandantes } from '../../services/Mandantes';
import { getConfigCarpetaMandante } from '../../services/CarpetaDocMandante';
import ListasAsignacion from './ListasAsignacion';

const AsignaManDocMaq = () => {
    const [centroData, setCentroData] = useState([]);
    const [idCentro, setIdCentro] = useState('');

    const [dataMandante, setDataMandante] = useState([]);
    const [idMandante, setIdMandante] = useState('');

    const [idMaquina, setIdMaquina] = useState('');
    const [equipoData, setEquipoData] = useState([]);
    const [generalesData, setGeneralesData] = useState([]);
    const [relData, setRelData] = useState([]);
    const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

    useEffect(() => {
        const fetchData = async () => {
            // const misCentros = await getCentroCosto();
            // setCentroData(misCentros);
            const misMandantes = await getMandantes();
            setDataMandante(misMandantes);
            const misEquipos = await getMaquinas();
            setEquipoData(misEquipos);
            const misDoctos = await getDocumentosGenerales();
            setGeneralesData(misDoctos);
        };
        fetchData();
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            const [misDocRel, configMandante] = await Promise.all([
                getManDocuMaqFiltro(idMandante, idMaquina),
                getConfigCarpetaMandante(idMandante),
            ]);

            const mandanteSet = new Set(
                Array.isArray(configMandante) ? configMandante.filter(c => c.selected).map(c => c._id) : []
            );
            const machineSet = new Set(
                Array.isArray(misDocRel) ? misDocRel.map(r => r.idDocuGeneral) : []
            );

            const relDataSeek = generalesData.map((doc) => ({
                _id: doc._id,
                documentoGeneral: doc.documentoGeneral,
                tipo: doc.tipo || 'Logística',
                state: (mandanteSet.has(doc._id) || machineSet.has(doc._id)) ? 'Finalizadas' : 'Pendientes',
            }));

            setRelData(relDataSeek);
        };
        if (idMandante && idMaquina) {
            fetchData();
        } else {
            setRelData([]);
        }
    }, [idMandante, idMaquina, generalesData]);

    const handleChangeIdCentro = (e) => {
        setIdCentro(e.target.value);
    };

    const handleChangeIdMandante = (e) => {
        setIdMandante(e.target.value);
    };

    const handleChangeIdMaquina = (e) => {
        setIdMaquina(e.target.value);
    };

const handleRefreshDataTable = async (opcion) => {
    if (opcion === "REFRESH" && idMandante && idMaquina) {
        const [misDocRel, configMandante] = await Promise.all([
            getManDocuMaqFiltro(idMandante, idMaquina),
            getConfigCarpetaMandante(idMandante),
        ]);

        const mandanteSet = new Set(
            Array.isArray(configMandante) ? configMandante.filter(c => c.selected).map(c => c._id) : []
        );
        const machineSet = new Set(
            Array.isArray(misDocRel) ? misDocRel.map(r => r.idDocuGeneral) : []
        );

        const relDataSeek = generalesData.map((doc) => ({
            _id: doc._id,
            documentoGeneral: doc.documentoGeneral,
            tipo: doc.tipo || 'Logística',
            state: (mandanteSet.has(doc._id) || machineSet.has(doc._id)) ? 'Finalizadas' : 'Pendientes',
        }));

        setRelData(relDataSeek);
    }
};

    return (
        <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">

            <div className="container mx-auto p-2 md:p-2">
                <h1 className="text-2xl font-semibold mb-6">Asignación Documentos por Maquinas </h1>
                <div className="grid grid-cols-1 md:grid-cols-1 gap-8">
                    <div className="md:col-span-3 bg-white p-6 rounded-lg shadow-lg">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" >
                            <div className="col-span-2">
                                <div className="flex flex-col ">
                                    <label className="text-xs font-semibold mb-1">Mandante</label>
                                    <select className={inputClass} name="idMandante"
                                        value={idMandante} onChange={handleChangeIdMandante}>
                                        <option value=""></option>
                                        {dataMandante?.map((item, index) => (
                                            <option key={item._id} value={item._id}>{item.razonSocial}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" >
                            <div className="col-span-2">
                                <div className="flex flex-col">
                                    <label className="text-xs font-semibold mb-1">Maquina</label>
                                    <select className={inputClass} name="idMaquina"
                                        value={idMaquina} onChange={handleChangeIdMaquina}>
                                        <option value=""></option>
                                        {equipoData?.map((item, index) => (
                                            <option key={item._id} value={item._id}>{item.codigo}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
                            <ListasAsignacion ListaDatos={relData} mandante={idMandante} maquina={idMaquina} onChangeDatos={handleRefreshDataTable} />
                        </div>
                    </div>
                </div>
            </div>

        </div>

    )
}

export default AsignaManDocMaq;